import { makeListReducer } from 'lib/list-helper/makeListReducer';
import { emptyRule, makeStage } from './dynamicRuleStages';

export const DYNAMIC_RULES_ACTIONS = {
  USER_OPENS_RULE: 'USER_OPENS_RULE',
  USER_CLOSES_RULE: 'USER_CLOSES_RULE',
  USER_CHANGES_RULE: 'USER_CHANGES_RULE',
  USER_CHANGES_STAGE: 'USER_CHANGES_STAGE',
  USER_ADDS_STAGE: 'USER_ADDS_STAGE',
  USER_REMOVES_STAGE: 'USER_REMOVES_STAGE',
  USER_APPLIES_PRESET: 'USER_APPLIES_PRESET',
  APP_STARTS_SAVING: 'APP_STARTS_SAVING',
  APP_FAILS_SAVING: 'APP_FAILS_SAVING',
};

const closedModal = () => ({
  isOpen: false,
  isSaving: false,
  isDirty: false,
  rule: emptyRule(),
  errors: {},
});

const INITIAL_DYNAMIC_RULES_STATE = {
  sortBy: 'name',
  modal: closedModal(),
};

const updateRule = (state, rule) => ({
  ...state,
  modal: { ...state.modal, rule, isDirty: true, errors: {} },
});

const NEXT_STAGE_FIELDS = ['okNextStageNo', 'failNextStageNo', 'skipNextStageNo'];

const DYNAMIC_RULES_REDUCER_CONFIG = {
  [DYNAMIC_RULES_ACTIONS.USER_OPENS_RULE]: (state, action) => ({
    ...state,
    modal: { ...closedModal(), isOpen: true, rule: action.payload },
  }),
  [DYNAMIC_RULES_ACTIONS.USER_CLOSES_RULE]: (state) => ({
    ...state,
    modal: closedModal(),
  }),
  [DYNAMIC_RULES_ACTIONS.USER_CHANGES_RULE]: (state, action) =>
    updateRule(state, { ...state.modal.rule, [action.payload.key]: action.payload.value }),
  [DYNAMIC_RULES_ACTIONS.USER_CHANGES_STAGE]: (state, action) => {
    const { index, changes } = action.payload;
    const stages = state.modal.rule.stages.map((stage, stageIndex) => {
      if (changes.isInitial) {
        return { ...stage, isInitial: stageIndex === index, ...(stageIndex === index && changes) };
      }
      return stageIndex === index ? { ...stage, ...changes } : stage;
    });
    return updateRule(state, { ...state.modal.rule, stages });
  },
  [DYNAMIC_RULES_ACTIONS.USER_ADDS_STAGE]: (state) => {
    const { stages } = state.modal.rule;
    const highest = Math.max(0, ...stages.map((stage) => Number(stage.stageNo) || 0));
    return updateRule(state, {
      ...state.modal.rule,
      stages: [...stages, makeStage({ stageNo: `${highest + 1}`, isInitial: !stages.length })],
    });
  },
  [DYNAMIC_RULES_ACTIONS.USER_REMOVES_STAGE]: (state, action) => {
    const removed = state.modal.rule.stages[action.payload];
    const removedNo = Number(removed.stageNo);
    const stages = state.modal.rule.stages
      .filter((_, index) => index !== action.payload)
      .map((stage) =>
        NEXT_STAGE_FIELDS.reduce(
          (next, field) =>
            Number(next[field]) === removedNo ? { ...next, [field]: null } : next,
          stage,
        ),
      );
    if (removed.isInitial && stages.length) stages[0] = { ...stages[0], isInitial: true };
    return updateRule(state, { ...state.modal.rule, stages });
  },
  [DYNAMIC_RULES_ACTIONS.USER_APPLIES_PRESET]: (state, action) =>
    updateRule(state, { ...state.modal.rule, ...action.payload }),
  [DYNAMIC_RULES_ACTIONS.APP_STARTS_SAVING]: (state) => ({
    ...state,
    modal: { ...state.modal, isSaving: true, errors: {} },
  }),
  [DYNAMIC_RULES_ACTIONS.APP_FAILS_SAVING]: (state, action) => ({
    ...state,
    modal: { ...state.modal, isSaving: false, errors: action.payload },
  }),
};

export const { reducer, initialState } = makeListReducer(
  DYNAMIC_RULES_REDUCER_CONFIG,
  INITIAL_DYNAMIC_RULES_STATE,
);
